import {EyeIcon} from "@/components/shared";
import React from "react";
import Loader from "../Loader";

interface SafetyRiskProps {
  isLoading?: boolean;
  instituteuserids?: any;
  safetyRiskWidget: safetyRiskWidgetSummary;
  openPopup?: (title: popupParams) => void;
  usersetting?: () => void;
}

interface safetyRiskWidgetSummary {
  acceleration: number;
  harshBraking: number;
  overSpeed: number;
  harshCornering?: number;
  totalBreach: number;
  vehicleInvolved: number;
  riskyDriver: number;
  totalVehicle: number;
  topRiskyDrivers: {
    driverName: string;
    driverEmpId: string;
    breachCount: number;
  }[];
  vehiclesInvolved: {
    vehicleName: string;
    driverName: string;
    breachCount: number;
  }[];
}

const defaultSafetyRiskWidget: safetyRiskWidgetSummary = {
  acceleration: 0,
  harshBraking: 0,
  overSpeed: 0,
  harshCornering: 0,
  totalBreach: 0,
  vehicleInvolved: 0,
  riskyDriver: 0,
  totalVehicle: 0,
  topRiskyDrivers: [
    {
      driverName: "",
      driverEmpId: "",
      breachCount: 0
    }
  ],
  vehiclesInvolved: [
    {
      vehicleName: "",
      driverName: "",
      breachCount: 0
    }
  ]
};

const SafetyRiskwidget: React.FC<SafetyRiskProps> = ({
  isLoading = false,
  safetyRiskWidget,
  openPopup,
  usersetting
}) => {
  const summary = safetyRiskWidget;
  const topDrivers = summary?.topRiskyDrivers ?? [];
  const topVehicles = summary?.vehiclesInvolved ?? [];

  const breachCards = [
    {
      label: "Sudden Acceleration",
      value: summary.acceleration,
      color: "#FC2A3D",
      icon: (
        <svg
          width="35"
          height="30"
          viewBox="0 0 32 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.6409 3.12976H13.2964V8.83844H18.6409V3.12976Z"
            fill="#ED2626"
          />
          <path
            d="M31.1073 2.31077C31.1073 1.03537 30.2459 0 29.1849 0H7.97163C6.91058 0 6.0492 1.03537 6.0492 2.31077V2.54608H6.83227V2.31077C6.83227 1.55306 7.34518 0.94125 7.97163 0.94125H29.1849C29.8153 0.94125 30.3243 1.56718 30.3282 2.35312L30.383 3.13436H25.3674L25.9038 8.83833H30.9233L31.2248 11.7797C31.2248 12.5374 30.7119 13.1492 30.0854 13.1492H29.4159C29.224 11.648 28.1317 10.5043 26.8514 10.5043C25.571 10.5043 24.4787 11.648 24.2868 13.1492H13.7663C13.5745 11.648 12.4821 10.5043 11.2018 10.5043C9.92147 10.5043 8.82909 11.648 8.63724 13.1492H7.96772C7.33735 13.1492 6.82835 12.5327 6.82835 11.7797V11.5444H6.04529V11.7797C6.04529 13.0551 6.90666 14.0905 7.96772 14.0905H8.63724C8.82909 15.5918 9.92146 16.7354 11.1979 16.7354C12.4743 16.7354 13.5666 15.5918 13.7585 14.0905H24.2868C24.4787 15.5918 25.571 16.7354 26.8474 16.7354C28.1238 16.7354 29.2162 15.5918 29.4081 14.0905H30.0776C30.5905 14.0905 31.0721 13.8505 31.4323 13.4128C31.8003 12.9704 32 12.3774 32 11.7185L31.2522 4.35328L31.1073 2.31077ZM11.2018 15.7942C10.2034 15.7942 9.3929 14.82 9.3929 13.6199C9.3929 12.4198 10.2034 11.4456 11.2018 11.4456C12.2002 11.4456 13.0107 12.4198 13.0107 13.6199C13.0107 14.82 12.2002 15.7942 11.2018 15.7942ZM26.8553 15.7942C25.8569 15.7942 25.0464 14.82 25.0464 13.6199C25.0464 12.4198 25.8569 11.4456 26.8553 11.4456C27.8537 11.4456 28.6642 12.4198 28.6642 13.6199C28.6642 14.82 27.8537 15.7942 26.8553 15.7942Z"
            fill="#ED2626"
          />
          <path
            d="M24.8467 3.12976H19.4984V8.83844H24.8428V3.12976H24.8467Z"
            fill="#ED2626"
          />
          <path
            d="M9.89407 3.90625H2.59198V4.8475H9.89407V3.90625Z"
            fill="#ED2626"
          />
          <path
            d="M11.3975 6.65942H0.0978699V7.60067H11.3975V6.65942Z"
            fill="#ED2626"
          />
          <path
            d="M9.89407 9.40771H2.59198V10.349H9.89407V9.40771Z"
            fill="#ED2626"
          />
          <path
            d="M9.89407 3.90625H2.59198V4.8475H9.89407V3.90625Z"
            fill="#ED2626"
          />
          <path
            d="M11.3975 7.60067V6.65942H5.74769H0.0978699V7.60067H11.3975Z"
            fill="#BD3333"
          />
          <path
            d="M11.3975 7.60067V6.65942H5.74769H0.0978699V7.60067H11.3975Z"
            fill="#ED2626"
          />
          <path d="M31.7142 16.8387H0V17.78H31.7142V16.8387Z" fill="#ED2626" />
        </svg>
      )
    },
    {
      label: (
        <>
          Harsh
          <br />
          Braking
        </>
      ),
      value: summary.harshBraking,
      color: "#F28A03",
      icon: (
        <svg
          width="35"
          height="30"
          viewBox="0 0 40 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.6041 24.6896C22.0683 25.0036 22.7914 25.0036 23.2557 24.6896L23.9212 24.2157L8.25998 12.9249L7.60263 13.3988C7.38077 13.5573 7.25752 13.772 7.25752 13.9971C7.25752 14.2193 7.38283 14.434 7.60263 14.5895L21.6041 24.6896Z"
            fill="#F28A03"
          />
          <path
            d="M16.1615 11.7634C15.2699 11.3266 14.2161 11.094 13.1377 11.1C11.6915 11.094 10.3028 11.5087 9.28396 12.2492L8.73341 12.652L13.1213 15.8154C16.2108 13.9849 16.2437 12.3027 16.1615 11.7634Z"
            fill="#F28A03"
          />
          <path
            d="M14.2883 16.6568L24.3867 23.9372L27.353 21.7987C27.6488 21.5899 27.844 21.3174 27.9118 21.0227C28.1316 19.9297 28.8218 18.9153 29.8838 18.12V18.1141L31.6505 16.8582L24.7977 11.9178L24.3129 12.2555C24.1424 12.3799 23.9596 12.4924 23.7624 12.5931C24.1732 13.5158 24.3006 14.4932 24.1321 15.4544C24.0828 15.7506 23.7336 15.9727 23.3186 15.9698H23.2118C22.762 15.9238 22.4456 15.6247 22.5052 15.3004C22.6325 14.5821 22.5565 13.8535 22.2833 13.1559C21.9423 13.2389 21.589 13.2937 21.2315 13.3218C21.1411 14.0771 20.8269 14.8117 20.3112 15.4722C20.0832 15.7536 19.582 15.8498 19.1876 15.6884C18.7952 15.5255 18.6576 15.1641 18.8815 14.8798C19.2759 14.3837 19.5163 13.8313 19.5882 13.2626C18.9288 13.1649 18.3023 12.9738 17.7476 12.6998C17.5258 13.7246 16.7205 15.1816 14.2883 16.6568ZM24.3867 18.049C25.4221 18.0504 26.3526 18.5006 26.7491 19.1893C27.1435 19.8794 26.9237 20.6718 26.1924 21.199C25.4611 21.7262 24.3621 21.8847 23.4048 21.6003C22.4496 21.3145 21.8251 20.6436 21.8231 19.8972C21.8251 18.8768 22.9714 18.0504 24.3867 18.049Z"
            fill="#F28A03"
          />
          <path
            d="M23.6389 11.0822L24.2388 10.6616C24.5592 10.435 25.0728 10.4379 25.3891 10.6675L33.4004 16.4431C33.5544 16.5557 33.6387 16.7067 33.6387 16.8637C33.6387 17.0222 33.5503 17.1747 33.3922 17.2843L32.8087 17.699L33.1128 17.9182C33.2709 18.0263 33.4784 18.087 33.6962 18.09C33.9139 18.0885 34.1235 18.0278 34.2796 17.9182L38.5934 14.8082C38.7475 14.6956 38.8317 14.5445 38.8317 14.3876V0.590742C38.8338 0.350827 38.6304 0.134615 38.3223 0.0457471C38.0162 -0.0460736 37.6629 0.00279954 37.4267 0.170146L23.5482 10.1814C23.3941 10.2924 23.3078 10.442 23.3078 10.599C23.3078 10.756 23.3941 10.9056 23.5482 11.0167L23.6389 11.0822Z"
            fill="#F28A03"
          />
          <path
            d="M8.15849 22.0779L10.9687 24.1039L14.4362 26.6097C14.7587 26.8408 15.2805 26.8408 15.6031 26.6097L16.2193 26.1654C16.5316 25.9299 16.5316 25.5597 16.2193 25.3242L14.5678 24.1335L12.069 23.5256C11.9149 23.6381 13.4893 24.8251 13.2715 24.8251C13.0538 24.8266 13.6774 24.3453 13.5234 24.2342C13.3672 24.1232 12.7586 24.2112 12.7586 24.0543C12.7566 23.8958 12.532 23.9247 12.686 23.8136L14.7074 24.2342L10.6565 21.3138L11.1002 22.6703C10.7777 22.9014 9.31035 22.2039 9.93754 22.6674C9.61708 22.4349 11.0568 22.9636 11.3793 22.7326L10.6565 21.3138L9.06248 20.1705L7.77239 20.0893C7.62243 20.2003 7.93104 20.8823 7.93104 20.6179C7.71124 20.6194 8.31257 20.283 8.15849 20.1705C8.00442 20.0594 9.31035 20.7749 9.31035 20.6179C9.31035 20.461 8.90841 20.2816 9.06248 20.1705L7.90386 19.3352L6.45769 18.2926C6.13723 18.063 5.61955 18.063 5.29913 18.2926L4.68285 18.7369C4.52878 18.848 4.4425 18.9975 4.4425 19.1545C4.4425 19.3115 4.52878 19.4611 4.68285 19.5722L8.15849 22.0779Z"
            fill="#F28A03"
          />
          <path
            d="M7.86251 23.297L4.37856 25.8028V28.125L9.46481 24.4522L7.86251 23.297Z"
            fill="#F28A03"
          />
          <path
            d="M24.3868 20.5546C24.7565 20.5532 25.0913 20.3917 25.2311 20.1444C25.3707 19.8971 25.2906 19.6128 25.0277 19.4247C24.7647 19.2366 24.3703 19.1818 24.0273 19.2855C23.6863 19.3892 23.4645 19.6306 23.4665 19.8971C23.4727 20.2614 23.8814 20.5532 24.3868 20.5546Z"
            fill="#F28A03"
          />
          <path
            d="M39.1783 28.8152H0.821691C0.367709 28.8152 3.64091e-06 29.0803 3.64091e-06 29.4076C3.64091e-06 29.7349 0.367709 30 0.821691 30H39.1783C39.6323 30 40 29.7349 40 29.4076C40 29.0803 39.6323 28.8152 39.1783 28.8152Z"
            fill="#F28A03"
          />
        </svg>
      )
    },
    {
      label: (
        <>
          Over
          <br />
          Speeding
        </>
      ),
      value: summary.overSpeed,
      color: "#6366F1",
      icon: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 71 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.5 0C26.0891 0.0136672 17.0652 4.04916 10.409 11.2214C3.75278 18.3971 0.00973714 28.1251 0 38.2706V42.4393C0 42.8015 0.133123 43.15 0.370847 43.4063C0.608571 43.6626 0.931878 43.8061 1.26788 43.8061H29.5446C30.1436 46.8336 32.6223 49 35.4971 49C38.3688 49 40.8507 46.8336 41.4465 43.8061H69.7321C70.0681 43.8061 70.3914 43.6626 70.6292 43.4063C70.8669 43.1501 71 42.8015 71 42.4393V38.2706C70.9905 28.1251 67.2471 18.397 60.591 11.2214C53.9348 4.04907 44.911 0.0139961 35.5 0ZM35.4968 46.2666C34.0579 46.2666 32.7614 45.3304 32.2131 43.8987C31.6616 42.4669 31.9658 40.82 32.9833 39.7231C33.9976 38.6262 35.5285 38.3016 36.8566 38.8928C38.1846 39.4873 39.0499 40.8848 39.0499 42.4328C39.0468 44.548 37.4589 46.2632 35.4968 46.2666ZM35.4968 35.865C35.294 35.865 39.981 37.7579 39.7845 37.7784L56.3943 28.0059C54.7715 26.8033 55.4658 28.0059 56.3943 28.0059L54.7715 25.819L49.4972 28.8806C49.4972 31.8695 50.7143 28.8806 49.4972 28.8806L40.1657 33.6918C40.1657 33.6918 37.5125 35.3786 35.1743 35.4984C34.7932 35.5179 34.1379 35.5773 33.5459 35.865C33.131 36.0666 32.5688 36.5484 32.5688 36.5484L31.2661 37.5984C30.7653 38.3331 29.7187 40.1805 29.5413 41.0724C29.3638 41.9642 9.94039 41.0724 9.94039 41.0724V39.1452H12.6916C13.3921 39.1452 13.9595 38.5335 13.9595 37.7784C13.9595 37.0232 13.3921 36.4116 12.6916 36.4116H10.0292C10.4349 29.7792 13.0594 23.529 17.4145 18.8246L19.3923 20.9602L19.3955 20.9568C19.89 21.4899 20.6919 21.4899 21.1863 20.9568C21.6807 20.4238 21.6808 19.5592 21.1863 19.0262L19.2941 16.9863C23.5255 13.2413 28.7618 11.0681 34.2292 10.7913V13.6889C34.2292 14.4441 34.7966 15.0557 35.4971 15.0557C36.1976 15.0557 36.7649 14.4441 36.7649 13.6889V10.7913C42.2294 11.0681 47.4685 13.2413 51.6968 16.9863L49.8046 19.0262C49.3101 19.5593 49.3101 20.4238 49.8046 20.9568C50.2991 21.4898 51.101 21.4899 51.5986 20.9568L53.5796 18.8212L53.5764 18.8246C57.9315 23.5298 60.556 29.7792 60.9649 36.4116H58.2992C57.5987 36.4116 57.0313 37.0232 57.0313 37.7784C57.0313 38.5335 57.5987 39.1452 58.2992 39.1452H61.0504V41.0724H41.4496C40.8505 38.0415 39.0499 36.4116 35.8949 35.865H35.4968ZM68.4644 41.0725H63.5863V38.2706C63.5863 38.1236 63.5768 37.9801 63.5768 37.8332C63.5768 37.8127 63.5863 37.799 63.5863 37.7785C63.5863 37.7546 63.5737 37.7341 63.5737 37.7068C63.393 27.0251 58.0014 17.2392 49.3899 11.9531C40.7749 6.66692 30.2166 6.66692 21.6049 11.9531C12.99 17.2392 7.60128 27.0251 7.4179 37.7068C7.4179 37.7307 7.40522 37.7512 7.40522 37.7785C7.40522 37.799 7.41473 37.8127 7.41473 37.8332C7.41156 37.9801 7.40522 38.1236 7.40522 38.2706V41.0691L2.53664 41.0725V38.2706C2.53664 25.5761 8.8189 13.8421 19.0184 7.49666C29.218 1.14786 41.783 1.14786 51.9827 7.49666C62.1823 13.8421 68.4644 25.5761 68.4644 38.2706L68.4644 41.0725Z"
            fill="#4F7BFF"
          />
        </svg>
      )
    },
    {
      label: "Harsh Cornering",
      value: 0,
      color: "#D32E9F",
      icon: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 25 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.73571 9.84533L4.02066 8.627C4.17321 8.48236 4.42054 8.48236 4.57309 8.627C4.72564 8.77164 4.72564 9.00614 4.57309 9.15077L2.61996 11.0026C2.46742 11.1473 2.22009 11.1473 2.06754 11.0026L0.114411 9.15077C-0.0381371 9.00614 -0.0381371 8.77164 0.114411 8.627C0.26696 8.48236 0.51429 8.48236 0.666839 8.627L1.95432 9.84773C2.04017 4.3951 6.72875 0 12.5 0C15.34 0 18.0022 1.06972 19.9679 2.93859C20.1203 3.08343 20.1199 3.31792 19.9672 3.46237C19.8144 3.60681 19.5671 3.6065 19.4148 3.46167C17.5941 1.73076 15.1303 0.740741 12.5 0.740741C7.16108 0.740741 2.82282 4.80293 2.73571 9.84533ZM22.2643 10.1547L20.9793 11.373C20.8268 11.5176 20.5795 11.5176 20.4269 11.373C20.2744 11.2284 20.2744 10.9939 20.4269 10.8492L22.38 8.99737C22.5326 8.85273 22.7799 8.85273 22.9325 8.99737L24.8856 10.8492C25.0381 10.9939 25.0381 11.2284 24.8856 11.373C24.733 11.5176 24.4857 11.5176 24.3332 11.373L23.0457 10.1523C22.9598 15.6049 18.2712 20 12.5 20C9.66521 20 7.00743 18.9342 5.04255 17.0714C4.89 16.9267 4.88999 16.6922 5.04253 16.5476C5.19507 16.4029 5.4424 16.4029 5.59496 16.5476C7.41478 18.2729 9.87453 19.2593 12.5 19.2593C17.8389 19.2593 22.1772 15.1971 22.2643 10.1547Z"
            fill="#D32E9F"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.85199 10.6516C7.81115 10.4252 7.78989 10.1933 7.78989 9.95645C7.78989 9.7201 7.81115 9.48773 7.85199 9.2613H11.102C11.393 8.73249 12.0045 8.36804 12.7117 8.36804C13.4188 8.36804 14.0304 8.7325 14.3213 9.2613H17.5713C17.6122 9.48771 17.6334 9.7196 17.6334 9.95645C17.6334 10.1928 17.6122 10.4252 17.5713 10.6516H14.3213C14.1462 10.9704 13.8541 11.2296 13.4949 11.385V14.2693C13.2398 14.3055 12.9785 14.3244 12.7116 14.3244C12.4453 14.3244 12.1835 14.3055 11.9283 14.2693V11.385C11.5691 11.2296 11.2771 10.9704 11.102 10.6516H7.85199ZM12.7118 9.16248C12.2178 9.16248 11.8166 9.5185 11.8166 9.95694C11.8166 10.3954 12.2178 10.7509 12.7118 10.7509C13.2058 10.7509 13.6064 10.3949 13.6064 9.95694C13.6064 9.5185 13.2053 9.16248 12.7118 9.16248Z"
            fill="#D32E9F"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7116 4C16.416 4 19.4233 6.66885 19.4233 9.95636C19.4233 13.2439 16.416 15.9127 12.7116 15.9127C9.00727 15.9127 6 13.2439 6 9.95636C6 6.66885 9.00727 4 12.7116 4ZM12.7116 5.19118C9.74806 5.19118 7.34222 7.32629 7.34222 9.95638C7.34222 12.5865 9.74806 14.7216 12.7116 14.7216C15.6752 14.7216 18.0811 12.5865 18.0811 9.95638C18.0811 7.32629 15.6752 5.19118 12.7116 5.19118Z"
            fill="#D32E9F"
          />
        </svg>
      )
    }
  ];

  return (
    <div className="rounded-xl border bg-neo-white p-2">
      {/* Header */}
      <div className="mb-2 flex items-center justify-between">
        <div className="flex items-center gap-1">
          <div className="text-lg font-semibold">Safety Risk</div>
        </div>

        <div className="flex items-center gap-2">
          <h5
            className="cursor-pointer pr-2"
            title="View"
            onClick={() => openPopup?.({title: "Safety Risk Summary"})}
          >
            <EyeIcon size={18} />
          </h5>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col gap-2">
          {/* 4 breach type cards */}
          <div className="grid grid-cols-4 gap-2">
            {breachCards.map((card, index) => (
              <div
                key={index}
                className="flex flex-col gap-1 rounded-lg border bg-white  p-2"
              >
                {/* icon */}
                <div className="">{card.icon}</div>
                {/* number */}
                <span
                  className="text-lg font-bold leading-none"
                  style={{color: card.color}}
                >
                  {card.value}
                </span>
                {/* breaches label */}
                <span className="text-xs text-gray-400">Breaches</span>
                {/* card title */}
                <span className="text-xs font-bold text-gray-800">
                  {card.label}
                </span>
              </div>
            ))}
          </div>

          {/* Summary stats row */}
          <div className="grid grid-cols-3 divide-x divide-gray-200 rounded-lg border border-gray-200 bg-gray-50">
            <div className="flex flex-col gap-1 p-2">
              <div className="flex items-center justify-between">
                <div className="flex h-8 w-8 items-center justify-center rounded-md bg-[#FC2A3D1A]">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.5 0C7.3872 0 0 7.3872 0 16.5C0 25.6128 7.3872 33 16.5 33C25.6128 33 33 25.6128 33 16.5C33 7.3872 25.6128 0 16.5 0ZM18.0872 19.5684L18.538 6.47989C18.538 5.49163 17.7999 4.68307 16.8966 4.68307H16.1034C15.2009 4.68307 14.462 5.49163 14.462 6.47989L14.9128 19.5684C14.9128 20.5242 15.6275 21.3061 16.5 21.3061C17.3733 21.3061 18.0872 20.5242 18.0872 19.5684ZM16.5 23.9948C15.3062 23.9948 14.339 24.9629 14.339 26.1559C14.339 27.3497 15.307 28.3169 16.5 28.3169C17.6938 28.3169 18.6618 27.3489 18.6618 26.1559C18.661 24.9629 17.6938 23.9948 16.5 23.9948Z"
                      fill="#EF4444"
                    />
                  </svg>
                </div>
                <span className="text-base font-bold text-gray-800">
                  {summary.totalBreach}
                </span>
              </div>
              <span className="text-xs font-medium text-gray-600">
                Total Breach Count
              </span>
            </div>
            <div className="flex flex-col gap-1 p-2">
              <div className="flex items-center justify-between">
                <div className="flex h-8 w-8 items-center justify-center rounded-md bg-[#2563EB1A]">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.654617 14.7924C0.6891 15.1196 0.851027 15.4232 1.10907 15.6443C1.36711 15.8654 1.70293 15.9884 2.05156 15.9894H2.4008V17.3106C2.4013 17.4933 2.47847 17.6684 2.61543 17.7976C2.7524 17.9268 2.93801 17.9995 3.13171 18H5.32445C5.51815 17.9995 5.70376 17.9268 5.84073 17.7976C5.97769 17.6684 6.05486 17.4933 6.05536 17.3106V15.9894H11.9447V17.3106C11.9452 17.4933 12.0223 17.6684 12.1593 17.7976C12.2963 17.9268 12.4819 17.9995 12.6756 18H14.8683C15.062 17.9995 15.2476 17.9268 15.3846 17.7976C15.5216 17.6684 15.5987 17.4933 15.5992 17.3106V15.9894H15.9485C16.2971 15.9884 16.6329 15.8654 16.891 15.6443C17.149 15.4232 17.3109 15.1196 17.3454 14.7924H0.654617Z"
                      fill="#4F7BFF"
                    />
                    <path
                      d="M17.3531 14.2992V13.0788C17.3529 12.8143 17.2685 12.5559 17.1107 12.3372V6.66H17.126C17.3578 6.66 17.5801 6.57314 17.744 6.41854C17.9079 6.26393 18 6.05425 18 5.8356V4.0932C18.0002 3.98479 17.9778 3.87739 17.934 3.77716C17.8902 3.67694 17.8259 3.58584 17.7447 3.5091C17.6635 3.43235 17.567 3.37147 17.4609 3.32993C17.3547 3.28838 17.2409 3.267 17.126 3.267H17.1107V2.754C17.1087 2.02418 16.8004 1.32479 16.2533 0.808728C15.7061 0.292664 14.9646 0.00190059 14.1908 0L3.8092 0C3.03543 0.00190059 2.29393 0.292664 1.74679 0.808728C1.19965 1.32479 0.891377 2.02418 0.889362 2.754V3.267H0.874095C0.759154 3.267 0.64534 3.28838 0.539172 3.32993C0.433004 3.37147 0.336565 3.43235 0.255378 3.5091C0.17419 3.58584 0.109849 3.67694 0.0660361 3.77716C0.0222237 3.87739 -0.000198874 3.98479 5.20906e-05 4.0932V5.8266C-0.00120979 5.93562 0.0204664 6.04379 0.0638259 6.14485C0.107185 6.24591 0.171367 6.33786 0.252655 6.41537C0.333944 6.49287 0.430724 6.55441 0.537395 6.5964C0.644065 6.63839 0.758507 6.66001 0.874095 6.66H0.889362V12.3372C0.731582 12.5559 0.64714 12.8143 0.646997 13.0788V14.2992H17.3531ZM4.43134 13.5792C4.19799 13.5792 3.9699 13.5139 3.77591 13.3916C3.58192 13.2693 3.43075 13.0955 3.34154 12.8921C3.25234 12.6887 3.22909 12.465 3.27475 12.2491C3.32042 12.0333 3.43293 11.8351 3.59806 11.6796C3.76319 11.5241 3.97352 11.4183 4.20242 11.3756C4.43133 11.3328 4.66852 11.3551 4.88399 11.4396C5.09946 11.5241 5.28353 11.6669 5.41289 11.8501C5.54225 12.0333 5.6111 12.2485 5.61072 12.4686C5.61123 12.6149 5.58108 12.7599 5.52201 12.8951C5.46294 13.0304 5.37612 13.1533 5.26653 13.2569C5.15693 13.3604 5.02674 13.4425 4.88341 13.4984C4.74008 13.5544 4.58645 13.583 4.43134 13.5828V13.5792ZM13.5687 13.5792C13.3353 13.5796 13.107 13.5146 12.9128 13.3925C12.7185 13.2704 12.5671 13.0967 12.4776 12.8933C12.3881 12.69 12.3645 12.4662 12.41 12.2502C12.4554 12.0343 12.5678 11.8359 12.7329 11.6802C12.8979 11.5245 13.1082 11.4186 13.3372 11.3757C13.5661 11.3328 13.8034 11.355 14.019 11.4394C14.2346 11.5238 14.4188 11.6667 14.5482 11.8499C14.6777 12.0331 14.7466 12.2484 14.7462 12.4686C14.7464 12.6147 14.7162 12.7594 14.6571 12.8944C14.5981 13.0295 14.5114 13.1523 14.4021 13.2557C14.2928 13.3592 14.1629 13.4413 14.0199 13.4974C13.8769 13.5536 13.7236 13.5826 13.5687 13.5828V13.5792ZM14.9886 3.2634V10.0368H9.21567V3.267L14.9886 3.2634ZM6.01912 1.1574C6.01886 1.15276 6.0196 1.14812 6.02131 1.14376C6.02302 1.1394 6.02565 1.13541 6.02904 1.13204C6.03243 1.12868 6.03652 1.12599 6.04105 1.12416C6.04557 1.12233 6.05045 1.12139 6.05538 1.1214H11.937C11.942 1.12139 11.9468 1.12233 11.9514 1.12416C11.9559 1.12599 11.96 1.12868 11.9634 1.13204C11.9668 1.13541 11.9694 1.1394 11.9711 1.14376C11.9728 1.14812 11.9736 1.15276 11.9733 1.1574V2.2932C11.9736 2.29784 11.9728 2.30248 11.9711 2.30684C11.9694 2.3112 11.9668 2.31519 11.9634 2.31856C11.96 2.32192 11.9559 2.32461 11.9514 2.32644C11.9468 2.32827 11.942 2.32921 11.937 2.3292H6.06301C6.05808 2.32921 6.05321 2.32827 6.04868 2.32644C6.04415 2.32461 6.04007 2.32192 6.03667 2.31856C6.03328 2.31519 6.03065 2.3112 6.02894 2.30684C6.02724 2.30248 6.02649 2.29784 6.02675 2.2932L6.01912 1.1574ZM3.00386 3.2634H8.78438V10.0368H3.01149L3.00386 3.2634Z"
                      fill="#4F7BFF"
                    />
                  </svg>
                </div>
                <span className="text-base font-bold text-gray-800">
                  {summary.vehicleInvolved} / {summary.totalVehicle}
                </span>
              </div>
              <span className="text-xs font-medium text-gray-600">
                Vehicles Involved
              </span>
            </div>
            <div className="flex flex-col gap-1 p-2">
              <div className="flex items-center justify-between">
                <div className="flex h-8 w-8 items-center justify-center rounded-md bg-[#6366F11A]">
                  <svg
                    width="15"
                    height="18"
                    viewBox="0 0 24 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.06998 10.9052V12.8352C5.06998 15.9552 7.70998 18.4952 10.96 18.4952H12.68C15.93 18.4952 18.58 15.9552 18.58 12.8352V10.9652C19.05 10.7752 19.45 10.4452 19.67 9.97516C19.99 9.30516 19.9 8.56516 19.48 8.04516L19.13 7.51516V4.09516C19.13 2.81516 18.5 2.38516 17.84 1.93516C17.71 1.84516 17.57 1.75516 17.37 1.59516C16.51 0.955156 15.49 0.525156 14.42 0.345156L12.8 0.0851561C12.06 -0.0348439 11.31 -0.0248439 10.57 0.0951561L9.26998 0.325156C8.18998 0.515156 7.15998 0.965156 6.29998 1.63516C6.13998 1.75516 5.99998 1.85516 5.86998 1.94516C5.23998 2.39516 4.64998 2.81516 4.64998 4.05516V7.60516L4.41998 7.93516C3.91998 8.50516 3.79998 9.28516 4.10998 9.95516C4.30998 10.3752 4.64998 10.7052 5.06998 10.9052ZM17.3 7.42516L18.26 8.93516C18.36 9.06516 18.38 9.20516 18.32 9.34516C18.25 9.48516 18.09 9.63516 17.82 9.65516L13.61 8.58516C12.41 8.27516 11.15 8.28516 9.95998 8.60516L5.96998 9.66516C5.69998 9.63516 5.53998 9.48516 5.46998 9.34516C5.39998 9.19516 5.42998 9.05516 5.58998 8.86516L6.60998 7.42516C10.87 6.07516 16.04 7.13516 17.3 7.42516ZM12.69 17.0052H10.97C8.54998 17.0052 6.57998 15.1352 6.57998 12.8452V11.0452L10.36 10.0452C11.3 9.79516 12.3 9.78516 13.25 10.0352L17.09 11.0152V12.8452C17.08 15.1352 15.11 17.0052 12.69 17.0052ZM6.72998 3.18516C6.87998 3.08516 7.03998 2.96516 7.20998 2.83516C7.87998 2.31516 8.67998 1.95516 9.51998 1.81516L10.82 1.58516C11.39 1.48516 11.98 1.48516 12.55 1.57516L14.17 1.83516C15 1.96516 15.79 2.30516 16.51 2.84516C16.68 2.97516 16.84 3.07516 16.98 3.17516C17.56 3.57516 17.62 3.61516 17.62 4.09516V5.96516C16.21 5.62516 10.79 4.51516 6.13998 5.99516V4.05516C6.14998 3.59516 6.19998 3.55516 6.72998 3.18516Z"
                      fill="#6856F0"
                    />
                    <path
                      d="M17.05 20.1952H6.61C2.97 20.1952 0 23.1552 0 26.8052V27.7752C0 28.1852 0.34 28.5252 0.75 28.5252C1.16 28.5252 1.5 28.1852 1.5 27.7752V26.8052C1.5 23.9952 3.79 21.6952 6.61 21.6952H17.05C19.87 21.6952 22.16 23.9852 22.16 26.8052V27.7752C22.16 28.1852 22.5 28.5252 22.91 28.5252C23.32 28.5252 23.66 28.1852 23.66 27.7752V26.8052C23.65 23.1552 20.69 20.1952 17.05 20.1952Z"
                      fill="#6856F0"
                    />
                  </svg>
                </div>
                <span className="text-base font-bold text-gray-800">
                  {summary.riskyDriver}
                </span>
              </div>
              <span className="text-xs font-medium text-gray-600">
                Risky Drivers
              </span>
            </div>
          </div>

          {/* Bottom two columns */}
          <div className="grid grid-cols-[44%_54%] gap-2">
            {/* Top Risky Drivers */}
            <div className="rounded-lg border border-gray-200 p-2">
              {/* heading row */}
              <div className="mb-2 flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <div className="h-2 w-2 rounded-full bg-[#2563EB]"></div>
                  <span className="text-xs font-semibold">
                    Top Drivers Involved
                  </span>
                </div>
                {topDrivers.length > 0 && (
                  <div className="group relative">
                    <EyeIcon size={16} />
                    {/* tooltip — opens upward */}
                    <div className="absolute bottom-6  right-0 z-50 hidden w-52 rounded-lg border border-gray-300 bg-white shadow-lg group-hover:block">
                      <div className="divide-y divide-gray-100">
                        {topDrivers.map((driver, i) => (
                          <div
                            key={i}
                            className="flex items-center justify-between p-2"
                          >
                            <div className="flex items-center gap-1.5">
                              <div className="flex  flex-col gap-1">
                                <div className="text-xs font-medium text-gray-700">
                                  {driver.driverName || "No data"}
                                </div>
                                <div className="flex flex-row items-center gap-2">
                                  <div className="text-xs text-gray-400">
                                    {driver.driverEmpId || "No data"} |
                                  </div>
                                  <div className="flex  items-center gap-1">
                                    <div className=" text-xs font-bold text-[#FC2A3D]">
                                      {driver.breachCount ?? 0}
                                    </div>
                                    <div className="text-[12px] font-semibold text-gray-600">
                                      {(driver.breachCount ?? 0) === 1
                                        ? "- Breach"
                                        : "- Breaches"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* first item only risky driver*/}
              {topDrivers.length === 0 ? (
                <div className="flex items-center justify-center py-3 text-xs text-gray-400">
                  No data available
                </div>
              ) : (
                <div className="flex items-center justify-between">
                  <div className=" flex items-center gap-2">
                    <div className=" flex flex-col">
                      <span
                        className="text-xs font-medium text-gray-700"
                        title={topDrivers[0].driverName || "No data"}
                      >
                        {topDrivers[0].driverName
                          ? topDrivers[0].driverName.length > 13
                            ? `${topDrivers[0].driverName.slice(0, 13)}...`
                            : topDrivers[0].driverName
                          : "No data"}
                      </span>
                      <span className="text-[12px] text-gray-400">
                        {topDrivers[0].driverEmpId || "No data"}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col items-center">
                    <span className="text-sm font-bold text-[#FC2A3D]">
                      {topDrivers[0].breachCount ?? 0}
                    </span>
                    <span className="text-[12px] text-gray-400">Breaches</span>
                  </div>
                </div>
              )}
            </div>

            {/* Vehicles Involved */}
            <div className="rounded-lg border border-gray-200 p-2">
              {/* heading row */}
              <div className="mb-2 flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <div className="h-2 w-2 rounded-full bg-[#2563EB]"></div>
                  <span className="text-xs font-semibold">
                   Top Vehicles Involved
                  </span>
                </div>
                {topVehicles.length > 0 && (
                  <div className="group relative">
                    <EyeIcon size={16} />
                    {/* tooltip — opens upward */}
                    <div className="absolute bottom-6 right-0 z-50 hidden w-64 rounded-lg border border-gray-300 bg-white shadow-lg group-hover:block">
                      <div className="divide-y divide-gray-100">
                        {topVehicles.map((vehicle, i) => (
                          <div
                            key={i}
                            className="flex items-center justify-between p-2"
                          >
                            <div className="flex flex-col">
                              <span className="text-xs font-semibold text-gray-800">
                                {vehicle.vehicleName || "No data"}
                              </span>
                              <span className="text-[12px] text-gray-400">
                                {vehicle.driverName || "No data"}
                              </span>
                            </div>
                            <span
                              className="rounded px-1.5 py-0.5 text-[12px] font-medium text-[#FC2A3D]"
                              style={{background: "#FC2A3D1A"}}
                            >
                              {vehicle.breachCount ?? 0}{" "}
                              {(vehicle.breachCount ?? 0) === 1
                                ? "Breach"
                                : "Breaches"}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* first item only */}
              {topVehicles.length === 0 ? (
                <div className="flex items-center justify-center py-3 text-xs text-gray-400">
                  No data available
                </div>
              ) : (
                <div className="flex items-center justify-between">
                  <div className="flex flex-col">
                    <span
                      className="text-xs text-gray-800"
                      title={topVehicles[0].vehicleName || "No data"}
                    >
                      {topVehicles[0].vehicleName
                        ? topVehicles[0].vehicleName.length > 15
                          ? `${topVehicles[0].vehicleName.slice(0, 15)}...`
                          : topVehicles[0].vehicleName
                        : "No data"}
                    </span>
                    <span className="text-xs text-gray-400">
                      {topVehicles[0].driverName || "No data"}
                    </span>
                  </div>
                  <span
                    className="rounded px-1 py-0.5 text-xs font-medium text-[#FC2A3D]"
                    style={{background: "#FC2A3D1A"}}
                  >
                    {topVehicles[0].breachCount ?? 0}{" "}
                    {(topVehicles[0].breachCount ?? 0) === 1
                      ? "Breach"
                      : "Breaches"}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SafetyRiskwidget;
